import React, {useState, useEffect} from 'react';




const r = require.context('../images/QmcApprovedEvents', false, /\.(png|jpe?g|svg)$/);













function NewsCarousel() {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const loadedImages = r.keys().map(r); 
        setImages(loadedImages);              
      }, []);

    const RandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }



return (
    <>
    <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" style={{width: "50rem", margin: "auto", height: "100%", overflow: "hidden", aspectRatio: "16 / 9" }}>
    <div className="carousel-inner" style={{ margin: 'auto', width: '100%' }}>
        {images.map((image, index) => (
            <div
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                key={index}
            >
                <img src={image} className="d-block w-100" alt={`Slide ${index}`} style={{objectFit: "cover", objectPosition: "center", display: "block", position: "center"}}/>
            </div>
        ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
        </button>
    </div>
    </>
)

}

export default NewsCarousel;